export default "__VITE_ASSET__DxLOdQ4T__"